import usFlag from "../assets/images/flags/us.jpg"
import vietnam from "../assets/images/flags/vietnam.png"

const languages = {
  vi: {
    label: "Tiếng Việt",
    flag: vietnam,
  },
  en: {
    label: "English",
    flag: usFlag,
  },
}

export default languages
